import { ThunkDispatch } from 'redux-thunk';
import RootState from 'store/state';
import { createNotification, NotificationAction } from 'store/notification/notification.actions';
import AgentsAssistanceTypes from './agentsAssistance.types';
import AgentsAssistanceState from './agentsAssistance.state';
import * as AgentsAssistAPI from 'services/api/api.agentAssistance';

export type AgentsAssistanceAction =
    | { type: typeof AgentsAssistanceTypes.SET_AGENTS_ASSISTANCE_STATE, payload: AgentsAssistanceState }
    | { type: typeof AgentsAssistanceTypes.RESET_AGENTS_ASSISTANCE_STATE }

export function setAgentsAssistanceState(agentsAssistanceState: AgentsAssistanceState): AgentsAssistanceAction {
    return {
        type: AgentsAssistanceTypes.SET_AGENTS_ASSISTANCE_STATE,
        payload: agentsAssistanceState,
    }
}

export function resetAgentsAssistanceState(): AgentsAssistanceAction {
    return {
        type: AgentsAssistanceTypes.RESET_AGENTS_ASSISTANCE_STATE,
    }
}

export function getAgentsAssistByAgent() {
    return async (
        dispatch: ThunkDispatch<RootState, void, AgentsAssistanceAction>,
        getState: () => RootState
    ) => {
        const { auth, app, user } = getState();
        const companyID = app.ID;
        const instanceID = app.instance!.ID;
        const agentID = user.agentID;
        const token = auth.token!;

        try {
            const response = await AgentsAssistAPI.getAgentAssistByAgent(companyID, instanceID, agentID, token);
            response !== undefined && dispatch(setAgentsAssistanceState(response));
        } catch (error) {
            console.error('Error getting agents assist by agent : ', error);
        }
    }
}

export function updateAgentsAssist(newAgentsAssist: AgentsAssistanceState, isNewAssistEntry: boolean) {
    return async (
        dispatch: ThunkDispatch<RootState, void, AgentsAssistanceAction | NotificationAction>,
        getState: () => RootState
    ) => {
        const { auth, app } = getState();
        const companyID = app.ID;
        const instanceID = app.instance!.ID;
        const token = auth.token!;
        newAgentsAssist.instanceID = instanceID;
        try {
            if (isNewAssistEntry) {
                await AgentsAssistAPI.addNewAgentAssist(companyID, instanceID, newAgentsAssist, token);
            } else {
                await AgentsAssistAPI.updateAgentAssist(companyID, instanceID, newAgentsAssist, token);
            }

            // reset status bar state to default if we're sending up an update to resolve - this will only affect agents
            isNewAssistEntry ? dispatch(setAgentsAssistanceState(newAgentsAssist)) : dispatch(resetAgentsAssistanceState());
        } catch (error) {
            console.error('Error adding/updating agents assist: ', error);

            dispatch(createNotification({
                type: 'error',
                header: 'Error',
                text: 'There was a problem updating the hands up status. Please refresh and try again.',
            }));
        }
    }
}
